<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';

let globalId = 0;
export default defineComponent({
  name: 'OIconCheckMark',
  svgType: 'color',
  setup() {
    const classNames = ['o-svg-icon', 'o-icon-check-mark', 'type-color'];
    const isClient = ref(false);
    onMounted(() => {
      isClient.value = true;
    });
    return {
      isClient,
      classNames,
      globalId: globalId++,
    };
  },
});
</script>
<template>
  <svg fill="none" viewBox="0 0 24 24" :class="classNames">
    <template v-if="isClient">
      <path d="M0 0h24v24H0z"/><path fill="#fff" fill-rule="evenodd" d="M20.71 6.307q.138.137.213.301.075.166.09.357.014.192-.036.367-.048.17-.158.321l-.01.012-.089.106-9.96 9.934a1.75 1.75 0 0 1-2.343.122l-.008-.006-.118-.107-4.968-4.94a1.05 1.05 0 0 1-.286-.529 1.03 1.03 0 0 1 .054-.6 1.1 1.1 0 0 1 .228-.346 1.02 1.02 0 0 1 .657-.304q.193-.015.368.033.17.049.321.158l.013.008.106.09 4.737 4.71 9.715-9.69a1 1 0 0 1 .53-.284 1 1 0 0 1 .415.001 1 1 0 0 1 .53.286"/>
    </template>
  </svg>
</template>